import React, {useContext} from 'react';
import cookie from 'react-cookies';
import Selection from "@molecules/selection/selection";
import {FilterContext, FilterDispatcherContext} from "@providers/filters";
import {UpdateSelectionOptions, pluckKeyToArray} from "@hooks/selection.options";
import {isEmpty} from "@helpers/helpers";
import {saveCookie} from "@baseHelpers/cookie";

function DistrictsSelection(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {selected_filters} = useContext(FilterContext);
    const {options, selected_items} = props.items;
    const selectedItemsCopy = [...selected_items];
    let selectedFiltersDistrictIds = pluckKeyToArray(selected_filters.district_id, 'value');

    function handleChange(data) {

        let selectedDistrictIds = pluckKeyToArray(data.items, 'value');

        if (JSON.stringify(selectedDistrictIds) !== JSON.stringify(selectedItemsCopy)) {
            const new_option = UpdateSelectionOptions(options, data, true);

            cookie.remove('recent_districts');
            saveCookie('recent_districts', data.items.join(','));

            filterDispatcher({
                type: 'DISTRICTS_OPTIONS',
                payload: new_option
            });
        }
    }

    return (
        <div className={typeof props.className !== "undefined" ? props.className : ''}>
            <Selection
                type="multiple"
                name={props.name !== undefined ? props.name : 'district_id'}
                options={options}
                searchable
                limit_select={10}
                selected_items={selectedFiltersDistrictIds}
                caption_show={2}
                label="خیابان"
                onChange={(data) => handleChange(data)}
                showLabelAndSelected={(!!props.showLabelAndSelected)}
                showSelectedItemsInTop={props.showSelectedItemsInTop} // show selected items in header selection dropdown horizontal scrolling
                appendSelectedItemsInTop={true} // move selected items to top lists
                loading={(!isEmpty(props.loading) && props.loading)}
            />
        </div>
    )
}

export default DistrictsSelection;
